import { ComponentTypes } from "../Components/ComponentTypes";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { engineComponent, ArrayUtils } from "neo-common";
import { SwitchElement, SwitchElementAttributes } from "../Components/Elements/Graphics/SwitchElement";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";

@engineComponent(ComponentTypes.DisplayObject)
export class GroupTweens extends BaseElement {
    static CaseInit: string = "INIT";
    static CaseIntro: string = "INTRO";
    static CaseNormal: string = "NORMAL";
    static CaseGambleInit: string = "GAMBLE_INIT";
    static CaseBaseToGamble: string = "BASE_TO_GAMBLE";
    static CaseGambleToBase: string = "GAMBLE_TO_BASE";

    static CaseHighwinsIntro: string = "HIGHWINS_INTRO";
    static CaseHighwinsSoftOutro: string = "HIGHWINS_SOFT_OUTRO";
    static CaseHighwinsHardOutro: string = "HIGHWINS_HARD_OUTRO";
    static CaseHighwinsShake: string = "HIGHWINS_SHAKE";

    static CaseTeasingStart: string = "TEASING_START";
    static CaseTeasingEnd: string = "TEASING_END";

    private _childs: Object;
    private _childsNamesAccepted: Array<string>;

    constructor() {
        super();

        this._childs = [];
    }

    public createByNode(node: Element): void {
        super.createByNode(node);

        if (node.hasAttribute(GroupTweensAttributes.ELEMENT_NAMES)) {
            this._childsNamesAccepted = node.getAttribute(GroupTweensAttributes.ELEMENT_NAMES).split(";");
        }
    }

    public updateByNode(node: Element): void {
        super.updateByNode(node);

        if (this._childs && this._childsNamesAccepted) {
            this._childsNamesAccepted.forEach((value) => {
                if (this._childs[value]) {
                    if (this._childs[value] instanceof BaseElement) {
                        let base: BaseElement = <BaseElement>this._childs[value];
                        if (base) {
                            base.updateByNode(node);
                        }
                    } else if (this._childs[value] instanceof ImageElement) {
                        let image: ImageElement = <ImageElement>this._childs[value];
                        if (image) {
                            image.updateByNode(node);
                        }
                    }

                    // if has parameter CASE for SwitchElement only
                    if (node.hasAttribute(GroupTweensAttributes.CASE)) {
                        if (this._childs[value] instanceof SwitchElement) {
                            this._childs[value].goToCase(node.getAttribute(GroupTweensAttributes.CASE));
                        }
                    }
                }
            });
        }
    }

    public setChilds(childs: Object): void {
        this._childs = childs;
    }
}

const GroupTweensAttributes = {
    ELEMENT_NAMES: "ElementNames",
    CASE: "Case",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/GroupTweens.ts
 **/